module.exports = __webpack_public_path__ + "static/img/setting.ce9aefbe.png";